import { Button, Modal } from "@nabble/ui";

/** After asking for a new primary email: nothing changes until the link sent to it is opened. */
export function EmailChangeSentDialog({ sentTo, current, onDone }: { sentTo: string; current: string; onDone: () => void }): React.JSX.Element {
  return (
    <Modal open icon="mail" title="Check your new email" onClose={onDone} actions={<Button label="Done" onClick={onDone} />}>
      <p style={{ margin: 0 }}>
        {`We sent a link to ${sentTo}. Your email changes when you open it (it expires in 24 hours). Until then you keep signing in with ${current}.`}
      </p>
    </Modal>
  );
}
